import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { oneDark, oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism'
import { useColorScheme } from '@grammarly/design-system'
import type { HTMLProps } from 'react'

type Props = {
  readonly value: string
  readonly language: string
}

export function CodeBlock(props: Props) {
  const { value, language } = props

  const colorScheme = useColorScheme()
  const style = colorScheme.scheme === 'dark' ? oneDark : oneLight
  const customStyle = { fontSize: '12px' }
  const lineProps: HTMLProps<HTMLElement> = {
    style: { wordBreak: 'break-all', whiteSpace: 'pre-wrap' },
  }

  return (
    <SyntaxHighlighter
      language={language}
      style={style}
      customStyle={customStyle}
      lineProps={lineProps}
      wrapLines
    >
      {value}
    </SyntaxHighlighter>
  )
}
